document.addEventListener('DOMContentLoaded', () => {
  // Toggle for the "Fix" dropdown
  document.addEventListener('click', (e) => {
    const header = e.target.closest('.lp-article .js-fix-dropdown-toggle');
    if (header) {
      const content = header.nextElementSibling;
      if (content && content.classList.contains('fix-dropdown-content')) {
        content.classList.toggle('open');
      }
    }
  });

  // Toggle for each golf step explanation
  document.addEventListener('click', (e) => {
    const step = e.target.closest('.lp-article .js-golf-step');
    if (step) {
      const exp = step.querySelector('.golf-explanation');
      if (exp) exp.classList.toggle('open');
    }
  });
});
